<div class="main-container">

  <div class="page-header">
    <div class="title">
      <span class="title-text">Views &amp; Permissions</span>
      <p class="small-title">The view hierarchy, the permissions catalogue, and how they pair.</p>
    </div>
    <div class="header-actions">
      @if(tab === 'views'){
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="addView()">Add View</button>
      } @else {
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="addPermission()">Add Permission</button>
      }
    </div>
  </div>

  <div class="ac-tabs" role="tablist">
    <button type="button" class="ac-tab" role="tab" [class.active]="tab === 'views'" [attr.aria-selected]="tab === 'views'" (click)="setTab('views')">Views</button>
    <button type="button" class="ac-tab" role="tab" [class.active]="tab === 'permissions'" [attr.aria-selected]="tab === 'permissions'" (click)="setTab('permissions')">Permissions</button>
  </div>

  @if(tab === 'views'){

  <div class="table-container ac-table-region" role="region" aria-label="Views" tabindex="0">
    <table class="table ac-responsive-table">
      <thead class="table-head">
        <tr>
          <th scope="col">Label</th>
          <th scope="col">Name</th>
          <th scope="col">Type</th>
          <th scope="col">Level</th>
          <th scope="col">Applicable for</th>
          <th scope="col">Web route</th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(view of views; track view.viewId){
        <tr>
          <td data-label="Label">{{ view.viewLabel }}</td>
          <td data-label="Name">{{ view.viewName }}</td>
          <td data-label="Type">{{ view.viewType === 'C' ? 'Category' : 'Leaf' }}</td>
          <td data-label="Level">{{ view.level }}</td>
          <td data-label="Applicable for">{{ view.applicableFor }}</td>
          <td data-label="Web route">{{ view.webRoute || '-' }}</td>
          <td data-label="Status">{{ view.status === 1 ? 'Active' : 'Inactive' }}</td>
          <td class="ac-actions-column actions-cell" data-label="Actions">
            <button type="button" class="ac-secondary-small-btn" (click)="editView(view)">Edit</button>
            <button type="button" class="ac-secondary-small-btn" (click)="managePairs(view)">Permissions</button>
          </td>
        </tr>
        }
        @if(!isLoading && views.length === 0){
        <tr>
          <td colspan="8" class="empty-row">No views found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(tab === 'permissions'){

  <div class="table-container ac-table-region" role="region" aria-label="Permissions" tabindex="0">
    <table class="table ac-responsive-table">
      <thead class="table-head">
        <tr>
          <th scope="col">Label</th>
          <th scope="col">Name</th>
          <th scope="col">Default</th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(perm of permissions; track perm.permissionId){
        <tr>
          <td data-label="Label">{{ perm.permLabel }}</td>
          <td data-label="Name">{{ perm.permissionName }}</td>
          <td data-label="Default">{{ perm.isDefaultPermission ? 'Yes' : 'No' }}</td>
          <td data-label="Status">{{ perm.status === 1 ? 'Active' : 'Inactive' }}</td>
          <td class="ac-actions-column actions-cell" data-label="Actions">
            <button type="button" class="ac-secondary-small-btn" (click)="editPermission(perm)">Edit</button>
          </td>
        </tr>
        }
        @if(!isLoading && permissions.length === 0){
        <tr>
          <td colspan="5" class="empty-row">No permissions found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
